var map = {
	"./azure_toeic.png": "cd50",
	"./codeparty.png": "935d",
	"./connecter.png": "a6f0",
	"./gamelog.png": "52c3",
	"./geschenkt-top.jpeg": "7766",
	"./hoper.png": "c183",
	"./kakikata.png": "6828",
	"./kanji.gif": "b196",
	"./kingyo.png": "3517",
	"./lol.png": "7401",
	"./majan.jpeg": "1c68",
	"./tango_bot.png": "e944",
	"./wordbook.png": "75b6",
	"./wordbook2.png": "6e3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3296";